import { $ } from './../helpers/query'
import Swiper from './../imports/import-swiper'

export default class {
  constructor() {
    // attributes
    this.modalsAttr = 'data-modal';
    this.openModalAttr = 'data-open-modal';
    this.openBuildingAttr = 'data-floor';
    this.plansToggleAttr = 'data-plans-toggle';
    this.spacePlansToggleAttr = 'data-space-plans-toggle';
    this.planFloorAttr = 'data-plan-floor';
    this.planSpaceAttr = 'data-plan-space';
    // elements
    this.openBuildingBtns = $(`[${this.openBuildingAttr}]`);
    this.plansToggleBtns = $(`[${this.plansToggleAttr}]`);
    this.spacePlansToggleBtns = $(`[${this.spacePlansToggleAttr}]`);
    this.buildingContSel = '.modal-building';
    this.buildingSlideSel = '.modal-building__slide';
    this.buildingPlansSubtoggleSel = '.modal-building__subtoggle';
    this.isIOS = navigator.userAgent.match(/iPad|iPhone/i);
  }

  openBuilding() {
    this.openBuildingBtns.on('click', (e, btn) => {
      if (e.target.closest('.td-final')) return;

      let id;
      if (btn.hasAttribute(this.openModalAttr)) {
        id = btn.getAttribute(this.openModalAttr);
      } else {
        id = btn.querySelector(`[${this.openModalAttr}]`).getAttribute(this.openModalAttr);
      }

      const carouselEl = document.querySelector(`[${this.modalsAttr}="${id}"] ${this.buildingContSel}`);
      let initialSlide;
      if (isNaN(btn.getAttribute(this.openBuildingAttr))) {
        initialSlide = 0;
      } else {
        initialSlide = btn.getAttribute(this.openBuildingAttr);
      }
      this.initBuildingCarousel(carouselEl, initialSlide)
    })
  }

  initBuildingCarousel(container, initialSlide) {
    const carousel = new Swiper(container, {
      init: false,
      initialSlide: initialSlide,
      simulateTouch: false,
      speed: 700,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: container.querySelector('.modal-building__next'),
        prevEl: container.querySelector('.modal-building__prev'),
      },
    })

    carousel.on('init', () => {
      this.setNextArrowPosition(carousel)
    })
    carousel.on('slideChange', () => {
      this.setNextArrowPosition(carousel)
      this.resetPlansToggle()
    })
    carousel.init()
    this.setModalHeight()
  }

  setModalHeight() {
    if (this.isIOS) {
      $(this.buildingSlideSel).css({
        height: document.documentElement.clientHeight + 'px'
      })
    }
  }

  setNextArrowPosition(carousel) {
    const nextArrow = carousel.el.querySelector('.modal-building__next');
    const currSlide = carousel.slides[carousel.activeIndex];
    const title = currSlide.querySelector('.modal-building__title');
    const rightBound = title.getBoundingClientRect().right;
    const rightPercent = rightBound * 100 / document.documentElement.clientWidth + '%';
    nextArrow.style.left = rightPercent;
  }

  plansToggle() {
    this.plansToggleBtns.on('click', (e, btn) => {
      const slide = btn.closest(this.buildingSlideSel);
      const id = btn.getAttribute(this.plansToggleAttr);

      $(`[${this.plansToggleAttr}]`, slide).each((btnIn) => {
        if (btn == btnIn) {
          btnIn.classList.add('active')
        } else {
          btnIn.classList.remove('active')
        }
      })

      if (id == 'floor') {
        slide.querySelector(this.buildingPlansSubtoggleSel).classList.remove('active')
        $(`[${this.planFloorAttr}]`, slide).addClass('active');
        $(`[${this.planSpaceAttr}]`, slide).removeClass('active');
      } else {
        slide.querySelector(this.buildingPlansSubtoggleSel).classList.add('active')
        $(`[${this.planFloorAttr}]`, slide).removeClass('active');
        $(`[${this.planSpaceAttr}]`, slide).each((plan) => {
          if (plan.previousElementSibling.matches(`[${this.planFloorAttr}]`)) {
            plan.classList.add('active');
          }
        })
        $(`[${this.spacePlansToggleAttr}]`, slide).each((btn) => {
          if (!btn.previousElementSibling) {
            btn.classList.add('active')
          } else {
            btn.classList.remove('active')
          }
        })
      }
    })
  }

  spacePlansToggle() {
    this.spacePlansToggleBtns.on('click', (e, btn) => {
      const slide = btn.closest(this.buildingSlideSel);
      const btnId = btn.getAttribute(this.spacePlansToggleAttr);

      $(`[${this.spacePlansToggleAttr}]`, slide).each((btnIn) => {
        if (btnIn == btn) {
          btnIn.classList.add('active')
        } else {
          btnIn.classList.remove('active')
        }
      })

      $(`[${this.planSpaceAttr}]`, slide).each(plan => {
        const planId = plan.getAttribute(this.planSpaceAttr);

        if (planId == btnId) {
          plan.classList.add('active')
        } else {
          plan.classList.remove('active')
        }
      })
    })
  }

  resetPlansToggle() {
    $(`[${this.planFloorAttr}]`).addClass('active');
    $(`[${this.planSpaceAttr}]`).removeClass('active');
    $(`[${this.plansToggleAttr}], [${this.spacePlansToggleAttr}]`).each(btn => {
      if (!btn.previousElementSibling) {
        btn.classList.add('active')
      } else {
        btn.classList.remove('active')
      }
    })
    $(this.buildingPlansSubtoggleSel).removeClass('active')
  }
}
